import * as utils from "./misc";
import * as slick from "./plugins/slick.js";

import * as cart from "./woocommerce/cart.js";

import * as filters from "./woocommerce/filters.js";

export function init() {
  filters.init();
  cart.init();

  jQuery(".inner-overlay .lightbox .qty input").on("click", function (e) {
    e.preventDefault();
  });
  jQuery(".qty input").on("click", function (e) {
    e.preventDefault();
  });

  jQuery(".addtocart").on("click", function () {
    var qty = jQuery(".addtocartmodal").find(".addtocartqty").val();
    var prodid = jQuery(this).data("prodid");

    qty = parseInt(qty) <= 0 ? 1 : qty;

    jQuery.post(
      base.ajaxurl,
      {
        action: "addtobasket",
        productid: prodid,
        qty: qty,
      },
      function (r) {
        var response = JSON.parse(r);
        if (response.done == "true") {
          showModal(
            "<h3>Added</h3>This product has been added to your cart<br /><br /><div class='row'><div class='col-sm-6'><a href='" +
              basketURL +
              "'>View Cart</a></div><div class='col-sm-6'></div></div>"
          );
        }
      }
    );
  });

  jQuery(".btnaddtocart").on("click", function () {
    var prodid = jQuery(this).data("productid");
    var qty = jQuery(".qty-" + prodid).val();
    addToCart(prodid, qty);
  });

  jQuery("body").on("click", ".qtyinput", function (el) {
    console.log(el);
    jQuery(el).focus();
    el.stopPropagation();
    el.stopImmediatePropagation();
    el.preventDefault();
  });

  if (jQuery("#woocommerce-product-search-field-0").length > 0) {
    var thisselected = null;
    jQuery("#woocommerce-product-search-field-0")
      .autocomplete({
        focus: function () {
          // prevent value inserted on focus
          return false;
        },

        source: function (request, response) {
          jQuery.post(
            base.ajaxurl,
            {
              action: "products",
              term: request.term,
            },
            function (r) {
              var data = JSON.parse(r);

              response(data.products);
            }
          );
        },
        minLength: 2,
      })
      .data("uiAutocomplete")._renderItem = function (ul, item) {
      return jQuery("<li data-productid='" + item.productid + "'>")
        .append(
          `<div class='item'><div class='image'><img src='` +
            item.image +
            `'></div><div class='details'><div class='title'>` +
            item.label +
            `</div><div class='desc'>` +
            item.desc +
            `<div class='qty qty-` +
            item.productid +
            `'></div>` +
            `</div></div><div class='actions'><a class='btnaddtocart' onclick="addToCart('` +
            item.productid +
            `')"  data-productid='` +
            item.productid +
            `'>add to cart</a> <a href='` +
            item.url +
            `' class='viewproduct'>view product</a></div></div>`
        )
        .appendTo(ul);
    };
  }
}

function addToCart(prodid, qty) {
  basketURL = wc_add_to_cart_params.cart_url;

  showModal(
    `<div class='addtocartmodal'><h3>Add To Cart</h3>Please enter your desired quantity before clicking add to cart.<br /><br />
    <div class='row'><div class='col-sm-3'>QTY: <input type='text' value='1' class='addtocartqty' /></div>
    <div class='col-sm-6'><a data-prodid="` +
      prodid +
      `"class='addtocart btn'>Add to cart</a></div></div></div>`
  );
}

function autoCompleteQTY(el) {
  jQuery(".ui-autocomplete").show();
  jQuery(this).focus();
}
